import "./Loader.css"; // Import the CSS for the loader

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader">
        <img
          width="110px"
          height="110px"
          style={{ borderRadius: "20px" }}
          src="/images/logo9.png"
          alt="logo"
        />
      </div>
    </div>
  );
};

export default Loader;
